import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidMultisyllabicKeyboardKlankvoeten } from '../../../../mechanics/rid-multisyllabic-keyboard-klankvoeten/rid-multisyllabic-keyboard-klankvoeten';

@Component({
  selector: 'app-syllabic-keyboard-plus-klankvoeten-page',
  imports: [RidMultisyllabicKeyboardKlankvoeten],
  templateUrl: './syllabic-keyboard-plus-klankvoeten-page.html',
})
export class SyllabicKeyboardPlusKlankvoetenPage {
  protected readonly $router = inject(Router);
}
